export default "__VITE_ASSET__DDDPu$GP__"